export const URL = {
  KNOWLEDGE_BASE: 'https://knowledge-base.yieldbird.com',
  PORTAL: 'https://portal.productboard.com/r1foanqndkwabnvuypb9e6xj/tabs/15-considered',
} as const
